/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from "@emotion/react";
import SearchIcon from "@material-ui/icons/Search";
import { useI18n } from "hooks/i18n/i18n";

import { BlackButton } from "../../../BlackButton";
import { CancelButton } from "../DateInput/components/CancelButton";
import {
  buttonsWrapperStyle,
  footerStyle,
  resultCountStyle,
  searchButtonStyle,
  searchIconStyle,
} from "./styles";

import type { FcWithoutChildren } from "types/fcWithoutChildren";

type Props = {
  canSearch: boolean;
  onClose: () => void;
  resultCount: number;
};

export const Footer: FcWithoutChildren<Props> = (props) => {
  const { canSearch, onClose, resultCount } = props;
  const { t } = useI18n();

  return (
    <footer css={footerStyle}>
      <span css={resultCountStyle}>
        {resultCount}
        {t("search.searchModal.footer.resultCountUnit")}
      </span>

      <div css={buttonsWrapperStyle}>
        <CancelButton onClick={onClose} />
        <BlackButton
          aria-disabled={!canSearch}
          disabled={!canSearch}
          css={searchButtonStyle}
          type="submit"
        >
          <SearchIcon css={searchIconStyle} />
          {t("search.searchModal.footer.doSearch")}
        </BlackButton>
      </div>
    </footer>
  );
};
